import { Cloud, CloudOff } from "lucide-react";
import { useEffect, useState } from "react";
import { useOfflineQueue } from "@/shared/offline/offlineQueue";

export function OfflineSyncBadge() {
  const queueCount = useOfflineQueue((state) => state.queue.length);
  const hydrate = useOfflineQueue((state) => state.hydrate);
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    void hydrate();

    const setOnlineStatus = () => setOnline(navigator.onLine);
    window.addEventListener("online", setOnlineStatus);
    window.addEventListener("offline", setOnlineStatus);

    return () => {
      window.removeEventListener("online", setOnlineStatus);
      window.removeEventListener("offline", setOnlineStatus);
    };
  }, [hydrate]);

  if (!online) {
    return (
      <span className="inline-flex items-center gap-2 rounded-full bg-danger/10 px-3 py-1 text-xs font-semibold text-danger">
        <CloudOff size={14} aria-hidden />
        Offline
      </span>
    );
  }

  if (queueCount > 0) {
    return (
      <span className="inline-flex items-center gap-2 rounded-full bg-accent/20 px-3 py-1 text-xs font-semibold text-accent-foreground">
        <Cloud size={14} aria-hidden />
        {queueCount} queued
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
      <Cloud size={14} aria-hidden />
      Synced
    </span>
  );
}
